import * as z from 'zod'
import { t } from 'i18next'

export const downloadSchema = z.object({
  title: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:landing_title_length_error') as string,
    }),
  titleInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:landing_title_in_dutch_length_error') as string,
    }),
  content: z
    .string()
    .trim()
    .max(255, {
      message: t('error:content_length_error') as string,
    })
    .optional(),
  contentInDutch: z
    .string()
    .trim()
    .max(255, {
      message: t('error:content_length_error') as string,
    })
    .optional(),
  mediaId: z.number({
    required_error: t('error:field_required') as string,
  }),
  mediaMobileId: z.number({
    required_error: t('error:field_required') as string,
  }),
  type: z.string(),
})

export type IDownload = z.infer<typeof downloadSchema>
